import React from 'react';
import Radium from 'radium';
import color from 'color';

const loadingElement = (props) => {
	const { showElement } = props;

	return (
		<div 
			className="typing-indicator" 
			style={[
				styles.container,
				showElement && styles.container.show
			]}
		>
			<div className="typing-indicator__dot m-first" style={[styles.dot, styles.dot.first]}></div>
			<div className="typing-indicator__dot m-second" style={[styles.dot, styles.dot.second]}></div>
			<div className="typing-indicator__dot m-third" style={[styles.dot, styles.dot.third]}></div>
		</div>
	);
}

// STYLES
const blinkKeyframes = Radium.keyframes({
	'50%': { opacity: '1' }
});

const transformMessage = Radium.keyframes({
	'0%': { 
		transform: 'translateY(20px)',
		opacity: 0
	},
	'100%': { 
		transform: 'translateY(0px)' ,
		opacity: 1
	}
});

const styles = {
	container: {
		display: 'inline-block',
		height: '25px',
		padding: '11px 12px',
		display: 'none',

		show: {
			display: 'block',
			animationName: transformMessage,
			animationDuration: '0.2s'
		}
	},

	dot: {
		backgroundColor: '#aeb5bf',
		height: '8px',
		width: '8px',
		display: 'inline-block',
		borderRadius: '50%',
		marginRight: '4px',
		opacity: '0.2',

		first: {
			animationName: blinkKeyframes,
			animationDelay: '0.3333s',
			animationDuration: '1s',
			animationIterationCount: 'infinite'
		},

		second: {
			animationName: blinkKeyframes,
			animationDelay: '0.6666s',
			animationDuration: '1s',
			animationIterationCount: 'infinite'
		},

		third: {
			animationName: blinkKeyframes,
			animationDelay: '0.9999s',
			animationDuration: '1s',
			animationIterationCount: 'infinite',
			marginRight: '0'
		}
	}
};


export default Radium(loadingElement);


// WEBPACK FOOTER //
// ./src/components/LoadingElement.js